import myStore from "stores/my";
import uiStore from "stores/ui";

export const handleChangePassword = (handleClose: () => void) => {
  handleClose();

  if (myStore.impersonatingUserInfo) {
    uiStore.showModal({
      type: "ChangeUserPasswordModal",
      persisted: true,
      props: {
        userId: myStore.impersonatingUserInfo.userId,
        userEmail: myStore.impersonatingUserInfo.emailAddress,
        showImpersonationWarning: true,
      },
    });
  } else {
    uiStore.showModal({
      type: "ChangeMyPasswordModal",
      persisted: true,
      props: {},
    });
  }
};
